import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api`;

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
};

const departmentService = {
  getAllDepartments: async () => {
    const response = await axios.get(`${API_URL}/departments`, getAuthHeaders());
    return response.data;
  },

  addDepartment: async (name, label) => {
    const response = await axios.post(`${API_URL}/departments`, { name, label }, getAuthHeaders());
    return response.data;
  },

  updateDepartment: async (id, name, label) => {
    const response = await axios.put(`${API_URL}/departments/${id}`, { name, label }, getAuthHeaders());
    return response.data;
  },

  deleteDepartment: async (id) => {
    const response = await axios.delete(`${API_URL}/departments/${id}`, getAuthHeaders());
    return response.data;
  }
};

export default departmentService;
